





















import { Vue, Component } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
import { UI_SET_PAGE } from '@/store/ui/constants'
import { EditorPage } from '@/store/ui/types'

@Component({ name: 'editor-mobile-header' })
export default class EditorMobileHeader extends Vue {
    @Mutation(UI_SET_PAGE)
    setPage!: (newPage: EditorPage) => void
}
